const ITEMS = [
  "Nok Chhonk — Odia & Bengali Kitchen",
  "Mozekaql — Food-Tech · Dec 2026",
  "Agro-Research",
  "Foundation Initiatives",
  "Vaishali Nagar · Jaipur",
  "FSSAI Licensed",
  "Startup India Recognized",
];

function Row({ items }) {
  return (
    <div className="marquee-row">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display text-lg font-light tracking-[0.12em] text-slate-300 md:text-xl">{item}</span>
          <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-gradient-to-r from-amber-400 to-cyan-400 md:mx-12" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee-wrap" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row items={ITEMS} />
        <div aria-hidden="true">
          <Row items={ITEMS} />
        </div>
      </div>
    </div>
  );
}
